var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompareLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 535,
    height: 535,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 92,
    width: 535,
    height: 535
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-682 -92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M836.648 307.059C874.605 294.597 916.177 300.181 949.5 322.217 982.823 300.181 1024.4 294.597 1062.35 307.059 1063.24 301.529 1063.7 295.94 1063.74 290.34 1063.74 227.245 1012.6 176.095 949.5 176.095 886.405 176.095 835.255 227.245 835.255 290.34 835.295 295.94 835.761 301.529 836.648 307.059Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.22 330.186C1063.18 364.378 1038.64 392.567 1006.29 408.207 1007.66 415.859 1008.34 423.618 1008.35 431.391 1008.36 469.054 992.105 504.888 963.767 529.697 981.258 540.13 1001.25 545.637 1021.61 545.635 1084.68 545.66 1135.82 494.555 1135.85 431.49 1135.86 388.827 1112.1 349.714 1074.22 330.075Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.671 398.51C980.09 376.655 967.15 357.254 949.5 342.781 931.85 357.254 918.91 376.655 912.329 398.51 936.398 406.907 962.602 406.907 986.671 398.51Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.386 545.747C897.753 545.749 917.742 540.241 935.233 529.808 906.895 504.999 890.644 469.165 890.65 431.502 890.655 423.729 891.345 415.971 892.712 408.319 860.365 392.678 835.82 364.489 824.778 330.298 768.792 359.328 746.941 428.247 775.971 484.234 795.609 522.108 834.724 545.875 877.386 545.858Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M949.5 520C976.16 498.355 991.638 465.842 991.631 431.502 991.582 425.905 991.135 420.318 990.294 414.783 963.793 423.478 935.207 423.478 908.706 414.783 907.865 420.318 907.418 425.905 907.369 431.502 907.362 465.842 922.84 498.355 949.5 520Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.78 323.555C1027.33 312.656 992.677 316.163 964.045 333.14 981.881 348.798 995.132 369.003 1002.39 391.6 1029.52 377.358 1049.82 352.857 1058.78 323.555Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.386 317.257C864.733 317.286 852.172 319.413 840.215 323.555 849.241 352.907 869.656 377.416 896.892 391.6 904.146 369.003 917.398 348.798 935.233 333.14 917.726 322.749 897.745 317.263 877.386 317.257Z",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompareLight);
export default __webpack_public_path__ + "static/media/compare_light.75c3e76afec3b56ce258b75952441607.svg";
export { ForwardRef as ReactComponent };